import { render, staticRenderFns } from "./emerData.vue?vue&type=template&id=070d24a2&scoped=true&"
import script from "./emerData.vue?vue&type=script&lang=js&"
export * from "./emerData.vue?vue&type=script&lang=js&"
import style0 from "./emerData.vue?vue&type=style&index=0&lang=css&"
import style1 from "./emerData.vue?vue&type=style&index=1&id=070d24a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070d24a2",
  null
  
)

export default component.exports